var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 511.99,
    viewBox: "0 0 512 511.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "finance",
    transform: "translate(0 -0.006)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_304",
    "data-name": "Ellipse 304",
    cx: 255.995,
    cy: 255.995,
    r: 255.995,
    transform: "translate(0.01 0.005)",
    fill: "rgba(14,127,138,0.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1538",
    "data-name": "Path 1538",
    d: "M505.36,292.524c-7.91-9.2-23.034-11.037-33.2-4.41-26.163,17.053-54.429,34.277-54.429,34.277h0a20.991,20.991,0,0,0,2.986-11.337c0-14.846-22.148-22.853-47.531-27.157l-116.4-26.729c-19.35-4.726-44.285-5.163-64.174,3.779h0c-4.8,2.157-8.174,1.14-15.619,1.4V371.6c9.113.8,19.569-.729,34,5.141,25.35,10.308,93.948,36.306,140.943,36.306,38.688,0,106.475-43.915,150.459-81.7A27.531,27.531,0,0,0,505.36,292.524Z",
    fill: "#f9ce95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1539",
    "data-name": "Path 1539",
    d: "M391.011,342.3c18.4,0,31.743-3.939,39.688-11.724a26.652,26.652,0,0,0,7.933-19.523,7.581,7.581,0,0,0-.149-1.495c-12.128,7.576-20.752,12.832-20.752,12.832h0c.192-.31.371-.632.548-.957-5.781,4.055-16.157,6.117-29.718,5.842l-.154,0H321.463a7.5,7.5,0,0,0,0,15H388.33Q389.686,342.3,391.011,342.3Z",
    fill: "#f2bf81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1540",
    "data-name": "Path 1540",
    d: "M127.9,400.214V228.52h43.574a9.34,9.34,0,0,1,9.34,9.341V390.875a9.341,9.341,0,0,1-9.34,9.341H127.9Z",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1541",
    "data-name": "Path 1541",
    d: "M180.811,312.381v78.492a9.341,9.341,0,0,1-9.341,9.341H127.9V321.722H171.47A9.34,9.34,0,0,0,180.811,312.381Z",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1542",
    "data-name": "Path 1542",
    d: "M2.749,218.521H120a9.334,9.334,0,0,1,9.334,9.334V399.524A9.334,9.334,0,0,1,120,408.858H50.648A255.517,255.517,0,0,1,2.749,218.521Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1543",
    "data-name": "Path 1543",
    d: "M11.2,331.056H120a9.334,9.334,0,0,0,9.334-9.334v77.8A9.334,9.334,0,0,1,120,408.859H50.648A255.159,255.159,0,0,1,11.2,331.056Z",
    fill: "#5a5b5b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_305",
    "data-name": "Ellipse 305",
    cx: 16.591,
    cy: 16.591,
    r: 16.591,
    transform: "translate(58.688 342.387)",
    fill: "#7f7e7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1544",
    "data-name": "Path 1544",
    d: "M331.2,57.082A103.877,103.877,0,1,0,473.1,95.1,103.993,103.993,0,0,0,331.2,57.082Z",
    fill: "#ffc30a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_748",
    "data-name": "Group 748"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1545",
    "data-name": "Path 1545",
    d: "M309.22,189.723A104,104,0,0,1,339.44,52.83a103.945,103.945,0,0,0-46.257,146.152C323.4,251.316,392.54,267.347,442.883,232A104,104,0,0,1,309.22,189.723Z",
    fill: "#ffa01a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_306",
    "data-name": "Ellipse 306",
    cx: 85.358,
    cy: 85.358,
    r: 85.358,
    transform: "translate(297.784 61.684)",
    fill: "#ffa01a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1546",
    "data-name": "Path 1546",
    d: "M362.769,208.088c-52.093-30.075-57.4-103.124-10.7-140.528-65.939,25.734-73.913,117.43-11.6,153.407a85.37,85.37,0,0,0,96.065-7.32A85.176,85.176,0,0,1,362.769,208.088Z",
    fill: "#ff8d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1547",
    "data-name": "Path 1547",
    d: "M392.4,139.542v-22.63a39.38,39.38,0,0,1,11.058,5.062,9.259,9.259,0,1,0,11.048-14.862A57.711,57.711,0,0,0,392.4,97.894V93.038a9.259,9.259,0,1,0-18.518,0v4.981c-34.109,7.14-38.266,46.107,0,56.519v22.627a39.464,39.464,0,0,1-11.065-5.082,9.259,9.259,0,0,0-11.01,14.89,57.67,57.67,0,0,0,22.074,9.214v4.86a9.259,9.259,0,1,0,18.518,0v-4.982C426.585,188.94,430.609,149.971,392.4,139.542Zm-27.1-12.913c-.485-4.378,4.3-7.851,8.579-9.393v17.756C368.408,132.608,365.617,129.429,365.306,126.629Zm27.1,50.231V159.094C404.406,164.336,403.314,172.948,392.4,176.86Z",
    fill: "#d17507"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayout);
export default __webpack_public_path__ + "static/media/payout.ac485fd8c991311f8aac3df1d85a8ae2.svg";
export { ForwardRef as ReactComponent };